import Vue from 'vue';
import Router from 'vue-router';

import store from '@/store/store';
// import firebase from '@/scripts/firebase';
import { speakersCheck } from '@/scripts/utils';
// import { capitalize } from 'lodash';

const Index = () => import('./views/Index.vue');
const BaseView = () => import('./views/BaseView.vue');
const Speaker = () => import('./views/Speaker.vue');
const ErrorPage = () => import('./views/404.vue');


Vue.use(Router);

const router = new Router({
  mode: 'history',

  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/:city(amsterdam|san-francisco|new-york)',
      name: 'home',
      component: BaseView,
    },
    {
      path: '/:city(amsterdam|san-francisco|new-york)/home',
      redirect: '/:city(amsterdam|san-francisco|new-york)',
    },
    {
      path: '/:city(amsterdam|san-francisco|new-york)/speakers',
      name: 'speakers',
      component: BaseView,
      children: [
        {
          path: ':speaker',
          name: 'speakers',
          component: Speaker,
        },
      ],
    },
    {
      path: '/:city(amsterdam|san-francisco|new-york)/schedule',
      name: 'schedule',
      component: BaseView,
    },
    {
      path: '/:city(amsterdam|san-francisco|new-york)/workshops',
      name: 'workshops',
      component: BaseView,
    },
    {
      path: '/:city(amsterdam|san-francisco|new-york)/venues',
      name: 'venues',
      component: BaseView,
    },
    // {
    //   path: '/:city(amsterdam)/adobe-meetup',
    //   name: 'adobe-meetup',
    //   component: BaseView,
    // },
    // {
    //   path: '/:city(amsterdam|san-francisco|new-york)/practical',
    //   name: 'practical',
    //   component: BaseView,
    // },
    {
      path: '/*',
      name: 'errorPage',
      component: ErrorPage,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Check firebase init
  // if (!firebase.database) firebase.init();

  document.body.classList.add('wait');

  const description = document.querySelector('meta[name="description"]');

  if (to.name === 'index' || to.name === 'errorPage') {
    document.title = store.state.seo.defaultTitle;
    description.setAttribute('content', store.state.seo.defaultDescription);
    next();
  } else {
    document.title = `Awwwards Conference - ${store.state.seo[to.params.city][to.name].title}`;
    description.setAttribute('content', store.state.seo[to.params.city][to.name].description);

    // Ask for the page data and the components map before navigating
    const pagePromise = store.dispatch('LOAD_FIREBASE_PAGE', {
      city: to.params.city,
      page: to.name,
    });

    const componentsPromise = store.dispatch('LOAD_FIREBASE_COMPONENTS');

    let speakersPromise = new Promise(resolve => resolve());
    if (to.name === 'speakers' || to.name === 'speaker') {
      speakersPromise = store.dispatch('LOAD_ALL_SPEAKERS', {
        city: to.params.city,
      });
    }

    Promise.all([
      pagePromise,
      componentsPromise,
      speakersPromise,
    ]).then(result => speakersCheck(result, to.params.city, next));
  }
});

router.afterEach(() => {
  if (Object.keys(store.state.media).length <= 0) {
    store.dispatch('LOAD_ALL_MEDIA');
  }
});

export default router;
